const recoilKeys = new Set<string>();

export function addRecoilKey(key: string) {
  if (recoilKeys.has(key)) {
    throw new Error(`Recoil key "${key}" is already used.`);
  }
  recoilKeys.add(key);
  return key;
}
